import { AuroraBackground } from "@/components/AuroraBackground";
import { AuroraOrb } from "@/components/AuroraOrb";

export const Loader = ({ label = "Inizializzazione Aurora…" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="app-loader">
    <AuroraBackground />
    <AuroraOrb size={160} testId="loader-orb" />
    <p className="hud-tag">{label}</p>
  </div>
);
